<template>
  <ui-popover panel-class="rd-pop--companies rcp-pop" :label="$t('meals')" focus="input[type=search]" @open="query = ''">
    <template #trigger="{ attrs, on }">
      <button
        type="button"
        class="ui-btn"
        :class="{ 'ui-btn--accent': filtered }"
        v-bind="attrs"
        :disabled="!options.length"
        data-rd-trigger="meals"
        v-on="on"
      >
        <v-icon size="16" :color="filtered ? '#9a3412' : '#5f5852'">mdi-silverware-fork-knife</v-icon>
        <span class="rd-bar-label">{{ label }}</span>
        <v-icon size="16" :color="filtered ? '#9a3412' : '#5f5852'">mdi-chevron-down</v-icon>
      </button>
    </template>

    <template #default="{ close }">
      <div class="rd-pop__head">
        <span>{{ $t("recipes_shell.meals_title") }}</span>
        <span class="rd-num">{{ $t("report_mobile.selected_of", { selected: ctl.pickedCount, total: options.length }) }}</span>
      </div>
      <label class="rd-pop__search">
        <v-icon size="16" color="#5f5852">mdi-magnify</v-icon>
        <span class="rd-visually-hidden">{{ $t("recipes_shell.search_meals") }}</span>
        <input v-model="query" type="search" :placeholder="$t('recipes_shell.search_meals')" />
      </label>
      <div class="rd-checklist rcp-checklist" role="group" :aria-label="$t('meals')">
        <label v-for="option in visible" :key="option.key">
          <input type="checkbox" :checked="ctl.isMealOn(option.key)" @change="ctl.toggleMeal(option.key)" />
          <span>{{ option.label }}</span>
          <em class="rd-num">{{ option.portions ? ctl.fq(option.portions) : $t("recipes_shell.no_portions") }}</em>
        </label>
        <span v-if="!visible.length" class="rd-muted">{{ $t("report_mobile.no_results") }}</span>
      </div>
      <div class="rd-pop__links">
        <button type="button" class="ui-text-btn" @click="ctl.setAllMeals(true)">{{ $t("report_mobile.all") }}</button>
        <button type="button" class="ui-text-btn" @click="ctl.setAllMeals(false)">{{ $t("report_desktop.none") }}</button>
        <button type="button" class="ui-text-btn rd-pop__done" @click="close(true)">{{ $t("report_desktop.done") }}</button>
      </div>
    </template>
  </ui-popover>
</template>

<script>
import { matches } from "../recipesLogic";

/** Izbor jela u traci: dugme "5 od 9 jela" i iskačući spisak sa pretragom i brojem porcija pored svakog jela. */
export default {
  name: "RecipePicker",
  inject: { ctl: "recipesCtl" },
  data: () => ({ query: "" }),
  computed: {
    options() {
      return this.ctl.mealOptions;
    },
    filtered() {
      return this.options.length > 0 && this.ctl.pickedCount < this.options.length;
    },
    label() {
      return this.options.length
        ? this.$t("recipes_shell.meals_of", { selected: this.ctl.pickedCount, total: this.options.length })
        : this.$t("recipes_shell.meals_title");
    },
    visible() {
      return this.options.filter((option) => matches(option.label, this.query));
    },
  },
};
</script>
